// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__by1IS","info":"UpdateTermsInfo_info__3AFdk"};